import React, { Component } from 'react';
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { Document, Page } from 'react-pdf';

class ImageAndPDFViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      details: {},
      isLoading: false,
      pageNumber: 1,
      scale: 1,
      imageWidth: 570,
      imageHeight: 590
    }
    this.toggle = this.toggle.bind(this);
  }

  toggle(data) {
    this.setState(prevState => ({
      ...prevState,
      modal: !prevState.modal,
      details: data
    }));
    this.setState({
      scale: 1,
      imageWidth: 570,
      imageHeight: 590
    });
  }

  zoomInPDF = () => {
    let { scale } = this.state;
    if (scale > 3) {
      return;
    }

    scale += 0.5;
    this.setState({ scale });
  }

  zoomOutPDF = () => {
    let { scale } = this.state;
    if (scale <= 1) {
      return;
    }
    scale -= 0.5;
    this.setState({ scale });
  }

  zoomInImage = () => {
    let { imageWidth, imageHeight } = this.state;

    if (imageWidth > 1300) {
      return;
    }

    imageWidth += 100;
    imageHeight += 100;
    this.setState({ imageWidth, imageHeight });
  }

  zoomOutImage = () => {
    let { imageWidth, imageHeight } = this.state;
    if (imageWidth <= 570) {
      return;
    }
    imageWidth -= 100;
    imageHeight -= 100;
    this.setState({ imageWidth, imageHeight });
  }

  render() {
    let { details, imageWidth, scale, pageNumber } = this.state;
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.toggle}>&times;</button>;
    return (
      <>
        {this.state.isLoading && <CustomSpinner />}
        <Modal isOpen={this.state.modal} toggle={this.toggle} external={externalCloseBtn} className="modal-md modal-lg custom-confirm-modal" style={{ width: '50%', maxWidth: '1600px' }} backdrop={this.backdrop ? 'static' : 'nostatic'}>
          <div className="d-flex-column">
            <div className="confirm-modal-title-wrapp">
              <span className="confirm-modal-title">{this.props.title}</span>
              <FontAwesomeIcon className="pull-right cursor-pointer" onClick={() => this.toggle({})} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
            </div>
          </div>
          <ModalBody classNam="d-flex-column" id="activity-deatil">
            <div className="activity-detail">
              <>
                {
                  details.type === 'pdf' &&
                  <>
                    <Row style={{ marginTop: '15px' }}>
                      <Col xl="10" md="10" sm="8" xs="8">
                        <span className="invoice-1jpg">
                        </span>
                      </Col>
                      <Col>
                        <div className="pull-right">
                          <FontAwesomeIcon onClick={this.zoomInPDF} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                          &nbsp;&nbsp;
                          <FontAwesomeIcon onClick={this.zoomOutPDF} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: '12px' }}>
                      <Col>
                        <Document
                          file={details.url}
                          onLoadSuccess={this.onDocumentLoadSuccess}
                          loading="Loading..."
                        // className="react-pdf"
                        >
                          <Page pageNumber={pageNumber} width="500" height="500" scale={scale} />
                        </Document>
                      </Col>
                    </Row>
                  </>
                }

                {
                  details.type !== 'pdf' &&
                  <>
                    <Row style={{ marginTop: '15px' }}>
                      <Col xl="10" md="10" sm="8" xs="8">
                        <span className="invoice-1jpg">
                        </span>
                      </Col>
                      <Col>
                        <div className="pull-right">
                          <FontAwesomeIcon onClick={this.zoomInImage} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                          &nbsp;&nbsp;
                          <FontAwesomeIcon onClick={this.zoomOutImage} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        </div>
                      </Col>
                    </Row>
                    <Row style={{
                      // maxWidth: '570px' 
                    }}>
                      <Col
                        style={{ textAlign: 'center' }}
                      >
                        <img src={details.url} alt={details.name} width={imageWidth} className="img-viewer" />
                      </Col>
                    </Row>
                  </>
                }
              </>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ImageAndPDFViewer;